import { useOtherSettings } from '@namespace/cms';
import { useMatchPaths } from '@namespace/router';

export const useIsCritAllowedOnCurrentPage = () => {
  const { routesWithDisabledCriticalNotifications } = useOtherSettings();

  return !useMatchPaths(routesWithDisabledCriticalNotifications, {
    end: false
  });
};
